<footer>
  Spectro 2025 All Rights Reserved | v.1.2
</footer>
